/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionhint3Inputs */

const en_qrerrorcorrectionhint3 = /** @type {(inputs: Qrerrorcorrectionhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With higher error correction the code stays readable when damaged or printed on a busy surface, but the pattern gets denser.`)
};

const de_qrerrorcorrectionhint3 = /** @type {(inputs: Qrerrorcorrectionhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit höherer Fehlerkorrektur bleibt der Code auch bei Beschädigung oder Druck auf unruhigem Untergrund lesbar, das Muster wird dafür dichter.`)
};

/**
* | output |
* | --- |
* | "With higher error correction the code stays readable when damaged or printed on a busy surface, but the pattern gets denser." |
*
* @param {Qrerrorcorrectionhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionhint3 = /** @type {((inputs?: Qrerrorcorrectionhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionhint3(inputs)
	return de_qrerrorcorrectionhint3(inputs)
});
export { qrerrorcorrectionhint3 as "qrErrorCorrectionHint" }